import { Pagination, Popconfirm, Table, Tag, Tooltip } from "antd";
import { AiOutlineDelete } from "react-icons/ai";
import { CiRead } from "react-icons/ci";
import { useNavigate } from "react-router-dom";

interface TokenDataTableProps {
  data: any[];
  page: number;
  current: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number, pageSize: number) => void;
  delete: (id: number) => void;
}

const TokenDataTable = (props: TokenDataTableProps) => {
  const navigate = useNavigate();

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const columns = [
    {
      title: "S No",
      dataIndex: "",
      key: "sno",
      render: (_: any, __: any, index: number) =>
        (props.page - 1) * props.pageSize + index + 1,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      render: (price: number) => `${price}`,
    },
    {
      title: "Duration",
      dataIndex: "duration",
      key: "duration",
    },
    {
      title: "Duration Type",
      dataIndex: "duration_type",
      key: "duration_type",
    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
      render: (time: string) => time || "",
    },
    {
      title: "Members",
      dataIndex: "user_count",
      key: "user_count",
      render: (item: any) => <Tag color="green">{item ? item : 0}</Tag>,
    },
    {
      title: "Created Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date: string) => formatDate(date),
    },
    {
      title: "Action",
      key: "action",
      render: (item: any) => (
        <div style={{ display: "flex", gap: 8 }}>
          <Tooltip title="View">
            <CiRead
              size={20}
              style={{ cursor: "pointer", color: "blue" }}
              onClick={() =>
                navigate(`/Auth/tokenDetails/${item?.id}`, {
                  state: { type: "Token" },
                })
              }
            />
          </Tooltip>
          {/* <Tooltip title="Edit">
            <CiEdit
              size={20}
              style={{ cursor: "pointer", color: "orange" }}
              // onClick={() => navigate(`/Auth/createSubscription/${item?.id}`)}
            />
          </Tooltip> */}
          <Tooltip title="Delete">
            <Popconfirm
              title="Delete the Token"
              onConfirm={() => props.delete(item?.id)}
              okText="Yes"
              cancelText="No"
            >
              <AiOutlineDelete
                size={20}
                style={{ cursor: "pointer", color: "red" }}
              />
            </Popconfirm>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <div>
      <Table
        size="small"
        dataSource={props.data}
        columns={columns}
        pagination={false}
        scroll={{ x: true }}
        rowKey="id"
      />
      <br />
      <br />
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Pagination
          total={props.total}
          current={props.current}
          pageSize={props.pageSize}
          showSizeChanger
          showTotal={(total) => `Total ${total} Tokens`}
          onChange={(page, pageSize) => props.onPageChange(page, pageSize)}
          responsive
        />
      </div>
    </div>
  );
};

export default TokenDataTable;
